export function transformNurseryDataLatLong (nursery: any) {
  //comes in as csv, return object
  if (typeof nursery.lat_long === 'string') {
    let latLongArray = nursery.lat_long.split(',');
    nursery.lat_long = {lat: parseFloat(latLongArray[0]), lng: parseFloat(latLongArray[1])};
  }
  return nursery;
}

export function makeIdKeyNurseryRating (nursery: any, id) {
  //comes in as csv, return object
  // let retVal[nursery.id] = {nursery};
  // console.log(retVal);
  // return retVal;
}